export interface NewsletterResponse {
  success: boolean;
  message: string;
}

const API_URL = import.meta.env.VITE_BLOG_API_URL || 'https://www.princeitsolution.com/api/';

export const newsletterService = {
  async subscribe(email: string, source: string = 'website'): Promise<NewsletterResponse> {
    const response = await fetch(`${API_URL}newsletter/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ email, source }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Subscription failed');
    }

    return response.json();
  },

  async unsubscribe(email: string): Promise<NewsletterResponse> {
    const response = await fetch(`${API_URL}newsletter/unsubscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Unsubscribe failed');
    }

    return response.json();
  }
};
